import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "default-table-area style-two all-projects" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle" }
const _hoisted_6 = { class: "text-body" }
const _hoisted_7 = { class: "flex-shrink-0" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "flex-grow-1 ms-2 position-relative top-1" }
const _hoisted_10 = { class: "mb-0 fs-14 fw-medium" }
const _hoisted_11 = { class: "text-body" }
const _hoisted_12 = { class: "text-body" }
const _hoisted_13 = { class: "text-body" }
const _hoisted_14 = { class: "text-body" }
const _hoisted_15 = { style: {"position":"absolute","width":"80%","height":"80%","background-color":"#ffffff","border-radius":"50%","display":"flex","align-items":"center","justify-content":"center"} }
const _hoisted_16 = {
  class: "text-body fw-semibold",
  style: {"font-size":"12px"}
}
const _hoisted_17 = {
  key: 0,
  class: "badge bg-primary bg-opacity-10 text-primary p-2 fs-12 fw-normal"
}
const _hoisted_18 = {
  key: 1,
  class: "badge bg-danger bg-opacity-10 text-danger p-2 fs-12 fw-normal"
}
const _hoisted_19 = { class: "d-flex align-items-center gap-1" }
const _hoisted_20 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_21 = { class: "material-symbols-outlined fs-16 text-primary" }
const _hoisted_22 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_23 = { class: "material-symbols-outlined fs-16 text-body" }
const _hoisted_24 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_25 = { class: "material-symbols-outlined fs-16 text-danger" }
const _hoisted_26 = { class: "p-4 pt-lg-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_PaginationTwo = _resolveComponent("PaginationTwo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"p-4\"><div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3\"><h3 class=\"mb-0\">Performance of Agents</h3><select class=\"form-select month-select form-control p-0 h-auto border-0 w-110\" style=\"background-position:right 0 center;\" aria-label=\"Default select example\"><option selected>Last 30 Days</option><option value=\"1\">Last 60 Days</option><option value=\"2\">Last 90 Days</option></select></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, "ID"),
                _createElementVNode("th", { scope: "col" }, "Agent Name"),
                _createElementVNode("th", { scope: "col" }, "Total Tickets"),
                _createElementVNode("th", { scope: "col" }, "Open Tickets"),
                _createElementVNode("th", { scope: "col" }, "Resolved Tickets"),
                _createElementVNode("th", { scope: "col" }, "Avg. Resolution Time"),
                _createElementVNode("th", { scope: "col" }, "Satisfaction Rate"),
                _createElementVNode("th", { scope: "col" }, "Availability"),
                _createElementVNode("th", { scope: "col" }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", _hoisted_6, _toDisplayString(item.id), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_RouterLink, {
                      to: "/help-desk/agents",
                      class: "d-flex align-items-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("img", {
                            src: item.agentName.image,
                            class: "wh-34 rounded-circle",
                            alt: "user"
                          }, null, 8, _hoisted_8)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("h6", _hoisted_10, _toDisplayString(item.agentName.name), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(item.totalTickets), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(item.openTickets), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(item.resolvedTickets), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(item.avgResolutionTime), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", {
                      style: _normalizeStyle({
                      position: 'relative',
                      width: '50px',
                      height: '50px',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: item.satisfactionRate.bgGradient,
                    })
                    }, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("p", _hoisted_16, _toDisplayString(item.satisfactionRate.percentage) + "% ", 1)
                      ])
                    ], 4)
                  ]),
                  _createElementVNode("td", null, [
                    (item.availability.available)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, " Available "))
                      : _createCommentVNode("", true),
                    (item.availability.notAvailable)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, " Not Available "))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("button", _hoisted_20, [
                        _createElementVNode("i", _hoisted_21, _toDisplayString(item.action.view), 1)
                      ]),
                      _createElementVNode("button", _hoisted_22, [
                        _createElementVNode("i", _hoisted_23, _toDisplayString(item.action.edit), 1)
                      ]),
                      _createElementVNode("button", _hoisted_24, [
                        _createElementVNode("i", _hoisted_25, _toDisplayString(item.action.delete), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_PaginationTwo, {
            items: "10",
            total: "30"
          })
        ])
      ])
    ])
  ]))
}